import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function accountsProfileReducer(state = initialState.accountsProfile, action) {
  switch (action.type) {
    case types.SET_ACCOUNTS_PROFILE: {
      return {
        ...state,
        profile: action.profile,
      };
    }
    default:
      return state;
  }
}
